import { ContractInvoiceClient } from "@lib/ShiOneClient";
import { useApi } from "../../../utils";
import { useQuery } from "@tanstack/react-query";
import { Invoice } from "shared-ui/src/features/contracts-feature/canonical"

export const useGetContractInvoices = (contractId: number) => {
  const api = useApi(ContractInvoiceClient);

  const getContractInvoices = async () => {
    return await api.getContractInvoices(contractId);
  };

  return useQuery<Invoice[], Error>({
    queryKey: ["contract-invoices", contractId],
    queryFn: getContractInvoices,
  });
};
